<template>
  <div class="sample-page">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/home">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          报告管理
          <template>
            <div class="breadcrumb-num">
              (<template v-for="item, index in verifyStatusStatData">
                {{ item.value }}<span class="span-num">{{ item.numbers }}</span>
                <template v-if="index != (verifyStatusStatData.length - 1)">，</template>
              </template>)
            </div>
          </template>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="page-handle">
      <div class="left">
        <a-button v-auth="'10605'" @click="appoint()" type="primary">指派给机构</a-button>
        <a-button v-auth="'10607'" @click="appointSubmitPeople()" type="primary">指派提交人</a-button>
        <a-button v-auth="'10621'" @click="appointPeople()" type="primary">指派审核人</a-button>
        <a-button v-auth="'10625'" @click="exportExcelClick()" type="primary">导出列表</a-button>
        <template>
          <a-popover overlayClassName="export-popover" placement="bottomLeft" title="请选择" v-model="popoverVisible"
            :overlayStyle="{ width: '500px' }" trigger="click">
            <template slot="content">
              <div class="export-content">
                <a-row :gutter="10" class="export-a-row-h">
                  <a-col :span="4" class="export-popover-label hospital-required">查询时间</a-col>
                  <a-col :span="8">
                    <a-select placeholder="请选择" style="width: 90%;" :value="exportSettlementOpt.timeType"
                      @change="onChangeSelectTType">
                      <a-select-option v-for="item in popoverTSelect" :key="item.id" :value="item.id">
                        {{ item.value }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="12">
                    <a-range-picker class="tool-item" @change="onChangePicker" :value="rPrckerVal" />
                  </a-col>
                </a-row>
                <a-row :gutter="10" class="export-a-row-h">
                  <a-col :span="4" class="export-popover-label">就诊医院</a-col>
                  <a-col :span="8">
                    <a-select placeholder="请选择" style="width: 90%" :value="exportSettlementOpt.hosOperate"
                      :allowClear="true" @change="onChangeSelectHOperate">
                      <a-select-option v-for="item in popoverHSelect" :key="item.id" :value="item.id">
                        {{ item.value }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="12">
                    <a-select placeholder="请选择" class="tool-item" :value="exportSettlementOpt.hosId" :allowClear="true"
                      @change="onChangeSelectHId">
                      <a-select-option v-for="item in hospitalData" :key="item.deptId" :value="item.deptId">
                        {{ item.deptName }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row :gutter="10" class="export-a-row-h">
                  <a-col :span="4" class="export-popover-label">测序中心</a-col>
                  <a-col :span="8">
                    <a-select placeholder="请选择" style="width: 90%" :value="exportSettlementOpt.seqOperate"
                      :allowClear="true" @change="onChangeSelectSOperate">
                      <a-select-option v-for="item in popoverSSelect" :key="item.id" :value="item.id">
                        {{ item.value }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="12">
                    <a-select placeholder="请选择" class="tool-item" :value="exportSettlementOpt.seqId" :allowClear="true"
                      @change="onChangeSelectSequenceId">
                      <a-select-option v-for="item in sequenceData" :key="item.deptId" :value="item.deptId">
                        {{ item.deptName }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row :gutter="10">
                  <a-col :span="4"></a-col>
                  <a-col :span="8"></a-col>
                  <a-col :span="12">
                    <a-button class="export-btn" type="primary" @click="exportSettlement" v-auth="'10626'">导出
                    </a-button>
                  </a-col>
                </a-row>

              </div>
            </template>
            <a-button type="primary" v-auth="'10626'">结算导出</a-button>
          </a-popover>
        </template>
        <a v-auth="'10622'" class="filter-btn ml20" @click="drawerCollectVisible = true">指派汇总
          <a-icon type="profile" />
        </a>
        <!-- <a-button>新建作业</a-button> -->
      </div>
      <div class="right">
        <a-cascader :value="molecularTypingId" :options="mtOptions" placeholder="请选择父级简称" change-on-select
          @change="onChangeMtOptions" />
        <a-input-search v-model="hosBarCode" @search="onSearch" placeholder="请输入协作组条码/姓名"
          style="width: 200px; margin-left: 10px" />
        <a-tooltip placement="bottomRight">
          <template slot="title"> 解读报告未在规定的时间范围内上传 </template>
          <a-checkable-tag class="cktag-warnig" v-model="warning" button-style="solid" @change="ckWarning">提醒
          </a-checkable-tag>
        </a-tooltip>
        <a class="filter-btn" @click="drawerVisible = true">筛选
          <a-icon type="filter" />
        </a>
        <a-drawer title="指派汇总" :width="600" placement="right" :closable="false" :visible="drawerCollectVisible"
          @close="onClose" :body-style="{ paddingBottom: '80px' }">
          <div class="filter-drawer-content">
            <div class="filter-drawer-title">
              提交人
              <a-icon type="right" />
            </div>
            <div class="drawer-page-content">
              <a-table class="hospital-table" :pagination="false" :columns="userVerifyColumns1" :loading="loading"
                :dataSource="userVerifyStatData1" :rowKey="
                  (record, index) => {
                    return index;
                  }
                " size="middle"></a-table>
            </div>
            <div class="filter-drawer-title">
              审核人
              <a-icon type="right" />
            </div>
            <div class="drawer-page-content">
              <a-table class="hospital-table" :pagination="false" :columns="userVerifyColumns2" :loading="loading"
                :dataSource="userVerifyStatData2" :rowKey="
                  (record, index) => {
                    return index;
                  }
                " size="middle"></a-table>
            </div>
          </div>
        </a-drawer>
        <a-drawer title="筛选" :width="600" placement="right" :closable="false" :visible="drawerVisible" @close="onClose"
          :body-style="{ paddingBottom: '80px' }">
          <div class="filter-drawer-content">
            <div class="filter-drawer-title">
              患者组
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!patientGroupId ? 'primary' : 'default'" @click="handleGroupClick({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in dataGroup" :key="item.id">
                <a-button :type="patientGroupId == item.id ? 'primary' : 'default'"
                  @click="handleGroupClick({ key: item.id })">
                  {{ item.groupName }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <!--  -->
            <div class="filter-drawer-title">
              提交人
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!submitterUserId ? 'primary' : 'default'"
                  @click="handleOperateUserFilterStatClick({ key: 'default', type: 1 })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in operateUserFilterStat1" :key="item.keyId">
                <a-button :type="submitterUserId == item.keyId ? 'primary' : 'default'"
                  @click="handleOperateUserFilterStatClick({ key: item.keyId, type: 1 })">
                  {{ item.value || '-' }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              审核人
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!verifyUserId ? 'primary' : 'default'"
                  @click="handleOperateUserFilterStatClick({ key: 'default', type: 2 })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in operateUserFilterStat2" :key="item.keyId">
                <a-button :type="verifyUserId == item.keyId ? 'primary' : 'default'"
                  @click="handleOperateUserFilterStatClick({ key: item.keyId, type: 2 })">
                  {{ item.value || '-' }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <!--  -->
            <div class="filter-drawer-title">
              MD审核状态
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!mdCheck ? 'primary' : 'default'" @click="checkMdCheckStatus({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in mdCheckData" :key="item.key">
                <a-button :type="mdCheck == item.key ? 'primary' : 'default'"
                  @click="checkMdCheckStatus({ key: item.key })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              MD已读
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!mdRead ? 'primary' : 'default'" @click="checkMdReadStatus({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in mdReadList" :key="item.keyId">
                <a-button :type="mdRead == item.keyId ? 'primary' : 'default'"
                  @click="checkMdReadStatus({ key: item.keyId })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <!-- <div class="filter-drawer-title">
              报告状态
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!operateStatus ? 'primary' : 'default'" @click="checkStatus({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in operateData" :key="item.id">
                <a-button :type="operateStatus == item.id ? 'primary' : 'default'" @click="checkStatus({ key: item.id })">
                  {{ item.name }}
                </a-button>
              </a-col>
            </a-row> -->
            <div class="filter-drawer-title">
              检测项目
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!applyItem ? 'primary' : 'default'" @click="checkApplyItem({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in commonDictData" :key="item.keyId">
                <a-button :type="applyItem == item.keyId ? 'primary' : 'default'"
                  @click="checkApplyItem({ key: item.keyId })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              审核状态
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!verifyStatus ? 'primary' : 'default'" @click="checkVerifyStatus({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in verifyStatusStatData" :key="item.keyId" v-if="item.keyId != ''">
                <a-button :type="verifyStatus == item.keyId ? 'primary' : 'default'"
                  @click="checkVerifyStatus({ key: item.keyId })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              跟踪状态
              <a-icon type="right" />
              <span class="filter-dt-prompt">多选</span>
            </div>
            <a-row>
              <a-col :span="8">
                <a-button :type="trackingStatusALL ? 'primary' : 'default'" @click="searchCheckbox(null, trackingOption)">
                  全部
                </a-button>
              </a-col>
              <a-col :span="8" v-for="item in trackingData" :key="item.keyId">
                <a-button :type="
                  trackingStatus.indexOf(item.keyId) > -1
                    ? 'primary'
                    : 'default'
                " @click="searchCheckbox(item, trackingOption)">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              就诊医院
              <a-icon type="right" />
              <span class="filter-dt-prompt">多选</span>
            </div>
            <a-row>
              <a-col :span="12">
                <a-button :type="hospitalAll ? 'primary' : 'default'" @click="searchCheckbox(null, hospitalOption)">
                  全部
                </a-button>
              </a-col>
              <a-col :span="12" v-for="item in hospitalData" :key="item.keyId">
                <a-button :type="
                  hospitalIds.indexOf(item.keyId) > -1
                    ? 'primary'
                    : 'default'
                " @click="searchCheckbox(item, hospitalOption)">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              报告机构
              <a-icon type="right" />
              <span class="filter-dt-prompt">多选</span>
            </div>
            <a-row>
              <a-col :span="12">
                <a-button :type="reportDeptAll ? 'primary' : 'default'" @click="searchCheckbox(null, reportDeptOption)">
                  全部
                </a-button>
              </a-col>
              <a-col :span="12" v-for="item in reportDeptData" :key="item.deptId">
                <a-button :type="
                  reportDeptIds.indexOf(item.deptId) > -1
                    ? 'primary'
                    : 'default'
                " @click="searchCheckbox(item, reportDeptOption)">
                  {{ item.deptName || '-' }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">
              测序中心
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="12">
                <a-button :type="!seqDeptId ? 'primary' : 'default'"
                  @click="handleSequenceFilterStatClick({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="12" v-for="item in sequenceFilterStat" :key="item.keyId">
                <a-button :type="seqDeptId == item.keyId ? 'primary' : 'default'"
                  @click="handleSequenceFilterStatClick({ key: item.keyId })">
                  {{ item.value || '-' }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
          </div>
          <div :style="{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
          }">
            <a-button style="margin-right: 8px" @click="resetDrawer">
              重置
            </a-button>
            <a-button type="primary" @click="okDrawer"> 确定 </a-button>
          </div>
        </a-drawer>
      </div>
    </div>
    <div class="page-content">
      <a-table class="hospital-table" :pagination="false" :rowSelection="rowSelection" :columns="columns"
        :loading="loading" :dataSource="reportData.rows" :customRow="rowClick" :rowClassName="setRowClassName"
        :rowKey="(record) => record.id" size="middle">
        <router-link v-auth="'10601'" slot="hosBarCode" slot-scope="text, record"
          :to="{ path: '/report/details', query: { id: record.id } }">{{ text }}
        </router-link>
        <template slot="warningStatus" slot-scope="text, record">
          <a-tag v-if="record.warningHours !== 0" :color="record.warningStatus === '临近' ? 'orange' : '#f50'">
            {{ record.warningStatus }}
          </a-tag>
          <a-tag v-else color="#87d068">正常</a-tag>
        </template>
        <template slot="mdCheck" slot-scope="text, record">
          <md-to-popinfo :itemId="record.bid" :recordItem="record" :authCode="10624" @updateRows="updateRows"
            @updateRowsPop="updateRowsPop"></md-to-popinfo>
          <!-- <span v-if="record.mdCheck == '未审核'" class="h-mdCheck not"
            >MD</span
          >
          <span v-else="record.mdCheck == '相符'" class="h-mdCheck">MD</span>
          <span v-else="record.mdCheck" class="h-mdCheck red">MD</span> -->
        </template>
      </a-table>
      <div class="pagination">
        <a-pagination @change="pageChange" :pageSize.sync="pageSize" v-model="page" size="small"
          :total="reportData.total" />
      </div>
    </div>
    <page-model @close="closeModel" :visible="visible">
      <appoint v-if="visible && isAppoint == 2" :selectedData="selectRows" @close="closeModel" @update="update">
      </appoint>
      <appoint-people v-if="visible && isAppoint == 1" :appointType="appointType" @close="closeModel" @update="update"
        :selectedData="selectRows"></appoint-people>
    </page-model>
    <h-confirm :visible="confirmVisible" @close="closeConfirm" @ok="okClick" :loadding.sync="confirmLoadding"
      :title="currentConfirmData.title" :content="currentConfirmData.content" :desc="currentConfirmData.desc">
    </h-confirm>
  </div>
</template>

<script>
import auth from "../../directives/auth-utils";
import Appoint from "./appoint";
import AppointPeople from "./appoint-people";
import MdToPopinfo from "./md-to-popinfo.vue";

const columns = [
  {
    title: "序号",
    customRender: (text, record, index) => `${index + 1}`,
    width: "4%",
  },
  {
    title: "提醒",
    dataIndex: "warningStatus",
    scopedSlots: { customRender: "warningStatus" },
    width: "5%",
  },
  {
    title: "协作组条码",
    dataIndex: "hosBarCode",
    scopedSlots: { customRender: "hosBarCode" },
  },
  {
    title: "患者姓名",
    dataIndex: "patientName",
    customRender: (text, record, index) => {
      if (!record.patientName) {
        return "-";
      } else {
        return record.patientName;
      }
    },
  },
  {
    title: "就诊医院",
    dataIndex: "hospitalName",
  },
  {
    title: "分子分型",
    dataIndex: "molecularTyping",
    customRender: (text, record, index) => {
      if (!record.molecularTyping) {
        return "-";
      } else {
        return record.molecularTyping;
      }
    },
  },
  {
    title: "检测项目",
    dataIndex: "applyItemName",
    customRender: (text, record, index) => {
      if (!record.applyItemName) {
        return "-";
      } else {
        return record.applyItemName;
      }
    },
  },
  {
    title: "跟踪状态",
    dataIndex: "trackingStatusName",
  },
  {
    title: "审核状态",
    dataIndex: "verifyStatusRemark",
    customRender: (text, record, index) => {
      if (!record.verifyStatusRemark) {
        return "-";
      } else {
        return record.verifyStatusRemark;
      }
    },
  },
  {
    title: "MD审核",
    dataIndex: "mdCheck",
    scopedSlots: { customRender: "mdCheck" },
  },
  {
    title: "报告机构",
    dataIndex: "deptName",
    customRender: (text, record, index) => {
      if (!record.deptName) {
        return "-";
      } else {
        return record.deptName;
      }
    },
  },
  {
    title: "提交人",
    dataIndex: "submitterName",
    customRender: (text, record, index) => {
      if (!record.submitterName) {
        return "-";
      } else {
        return record.submitterName;
      }
    },
  },
  {
    title: "审核人",
    dataIndex: "verifyName",
    customRender: (text, record, index) => {
      if (!record.verifyName) {
        return "-";
      } else {
        return record.verifyName;
      }
    },
  },
  {
    title: "分组",
    dataIndex: "groupName",
    customRender: (text, record, index) => {
      if (!record.groupName) {
        return "-";
      } else {
        return record.groupName;
      }
    },
  },

  // {
  //   title: "审核时间",
  //   dataIndex: "verifyTime",
  //   customRender: (text, record, index) => {
  //     if (!record.verifyTime) {
  //       return '-'
  //     } else {
  //       return record.verifyTime
  //     }
  //   }
  // },
  {
    title: "操作时间",
    dataIndex: "updateTime",
    customRender: (text, record, index) => {
      if (!record.updateTime) {
        return "-";
      } else {
        return record.updateTime;
      }
    },
  },
];
const userVerifyColumns1 = [
  {
    title: "序号",
    customRender: (text, record, index) => `${index + 1}`,
    width: "10%",
  },
  {
    title: "提交人",
    dataIndex: "submitterName",
    customRender: (text, record, index) => {
      if (!record.submitterName) {
        return "-";
      } else {
        return record.submitterName;
      }
    },
  },
  {
    title: "-",
    dataIndex: "notnum",
    scopedSlots: { customRender: "notnum" },
  },
  {
    title: "待提交",
    dataIndex: "wait",
    scopedSlots: { customRender: "wait" },
  },
  {
    title: "待审核",
    dataIndex: "reviewed",
    scopedSlots: { customRender: "reviewed" },
  },
  {
    title: "已通过",
    dataIndex: "adopt",
    scopedSlots: { customRender: "adopt" },
  },
  {
    title: "已提交",
    dataIndex: "failed",
    scopedSlots: { customRender: "failed" },
  },
  {
    title: "报告退回",
    dataIndex: "reback",
    scopedSlots: { customRender: "reback" },
  },
  {
    title: "结果退回",
    dataIndex: "resultReback",
    scopedSlots: { customRender: "resultReback" },
  },
];
const userVerifyColumns2 = [
  {
    title: "序号",
    customRender: (text, record, index) => `${index + 1}`,
    width: "10%",
  },
  {
    title: "审核人",
    dataIndex: "verifyName",
    customRender: (text, record, index) => {
      if (!record.verifyName) {
        return "-";
      } else {
        return record.verifyName;
      }
    },
  },
  {
    title: "-",
    dataIndex: "notnum",
    scopedSlots: { customRender: "notnum" },
  },
  {
    title: "待提交",
    dataIndex: "wait",
    scopedSlots: { customRender: "wait" },
  },
  {
    title: "待审核",
    dataIndex: "reviewed",
    scopedSlots: { customRender: "reviewed" },
  },
  {
    title: "已通过",
    dataIndex: "adopt",
    scopedSlots: { customRender: "adopt" },
  },
  {
    title: "已提交",
    dataIndex: "failed",
    scopedSlots: { customRender: "failed" },
  },
  {
    title: "报告退回",
    dataIndex: "reback",
    scopedSlots: { customRender: "reback" },
  },
  {
    title: "结果退回",
    dataIndex: "resultReback",
    scopedSlots: { customRender: "resultReback" },
  },
];

export default {
  data() {
    return {
      columns,
      rows: null,
      rowsPop: false,
      userVerifyColumns1,
      userVerifyColumns2,
      hosBarCode: "",
      reportData: {
        rows: [],
      },
      mtOptions: [],
      appointType: 0,
      page: 1,
      visible: false,
      loading: false,
      warning: false,
      confirmVisible: false,
      confirmLoadding: false,
      currentConfirmData: {},
      conAppointPeople: {
        title: "提示",
        content: "报告已指派，是否重新指派？",
        desc: "",
        operateType: "confirm-people",
      },
      conAppointRePeople: {
        title: "提示",
        content: "报告已指派，是否重新指派？",
        desc: "",
        operateType: "confirm-re-people",
      },
      conAppointDept: {
        title: "提示",
        content: "报告已指派，是否重新指派？",
        desc: "",
        operateType: "confirm-dept",
      },
      isAppoint: 0,
      selectRows: [],
      selectedRowKeys: [],
      reportStatusAry: [],
      statusText: "报告状态",
      verifyStatusText: "审核状态",
      verifyStatus: "",
      mdCheckText: "MD审核状态",
      mdCheck: "",
      mdRead: "",
      mdReadText: "MD已读",
      molecularTypingId: [],
      dataGroup: [],
      commonDictData: [],
      applyItem: "",
      groupTitle: "选择组",
      patientGroupId: "",
      pageSize: 10,
      operateStatus: "",
      dropdownTVisible: false,
      dropdownHVisible: false,
      opreateText: "跟踪状态",
      hospitalText: "就诊医院",
      hospitalIds: [],
      trackingStatus: [],
      trackingData: [],
      hospitalData: [],
      sequenceData: [],
      reportDeptIds: [],
      reportDeptData: [],
      reportDeptOption: {
        key: "deptId",
        value: "deptName",
        paramsKey: "reportDeptIds",
        allFlag: "reportDeptAll",
        allData: "reportDeptData",
      },
      reportDeptAll: false,
      trackingStatusALL: false,
      hospitalAll: false,
      trackingOption: {
        key: "keyId",
        value: "vaule",
        paramsKey: "trackingStatus",
        allFlag: "trackingStatusALL",
        allData: "trackingData",
      },
      trackingShow: [
        "待筛选",
        "待审核",
        "报告待上传",
        "报告已上传",
        "未通过",
        "通过",
        "报告退回",
        "结果退回",
        "已终止",
        "流程已完成",
      ],
      hospitalOption: {
        key: "keyId",
        value: "hospitaText",
        paramsKey: "hospitalIds",
        allFlag: "hospitalAll",
        allData: "hospitalData",
      },
      mdCheckData: [],
      operateData: [
        {
          id: "0",
          name: "报告已上传",
        },
        {
          id: "1",
          name: "报告待上传",
        },
      ],
      verifyData: [],
      mdReadList: [],
      sequenceFilterStat: [],
      seqDeptId: '',
      operateUserFilterStat1: [],
      operateUserFilterStat2: [],
      submitterUserId: '',
      verifyUserId: '',
      drawerVisible: false,
      drawerCollectVisible: false,
      popoverVisible: false,
      rPrckerVal: null,
      dowmSettlementOpt: {
        startTime: null,
        endTime: null
      },
      verifyStatusStatData: [],
      userVerifyStatData1: [],
      userVerifyStatData2: [],
      popoverTSelect: [
        { id: 0, value: "按报告" },
        { id: 1, value: "按作业" }
      ],
      popoverHSelect: [
        { id: 0, value: "=" },
        { id: 1, value: "!=" }
      ],
      popoverSSelect: [
        { id: 0, value: "=" },
        { id: 1, value: "!=" }
      ],
      exportSettlementOpt: {
        startTime: null,
        endTime: null,
        timeType: undefined,
        hosOperate: undefined,
        hosId: undefined,
        seqOperate: undefined,
        seqId: undefined,
      },

    };
  },
  components: { Appoint, AppointPeople, MdToPopinfo },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectRows = selectedRows;
          this.selectedRowKeys = selectedRowKeys;
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name,
          },
        }),
      };
    },
  },
  watch: {
    drawerVisible(val, oldVal) {
      if (val) {
        this.getMDCheckValue();
        this.getMDReadValue();
        this.gethospital();
        this.getCommonDict();
        this.getSequenceFilterStat();
      }
    },
    drawerCollectVisible(val, oldVal) {
      if (val) {
        this.getUserVerifyStat(1);
        this.getUserVerifyStat(2);
      }
    },
  },
  mounted() {
    this.getStorage();
    this.getVerifyStatusStat();
    this.getBigTypes();
    this.getTrackingData();
    this.getReportDeptList();
    this.getLayerLst(-1);
    this.getGroupList();
    this.getOperateUserFilterStat(1);
    this.getOperateUserFilterStat(2);
  },
  methods: {
    rowClick(record, index) {
      let $this = this;
      return {
        on: {
          click: () => {
            this.rows = index;
          },
        },
      };
    },
    setRowClassName(record, index) {
      let className = "";
      if (index === this.rows && this.rowsPop) {
        className = "clickrowstyle";
      }
      return className;
    },
    getLayerLst(id) {
      this.$get("mt/q/mtt").then((res) => {
        if (res.data.code == 1) {
          res.data.data.push({ value: -2, label: "空", children: [] });
          this.mtOptions = [
            { value: -1, label: "顶级", children: res.data.data },
          ];
        }
      });
    },
    getVerifyStatusStat() {
      this.$get("/report/report/getVerifyStatusStat", { module: 4 }).then((res) => {
        this.verifyStatusStatData = res.data.data;
      });
    },
    getUserVerifyStat(type) {
      this.loading = true;
      this.$get("/jobsmanage/jobs/getUserVerifyStat?type=" + type).then(
        (res) => {
          if (type == 1) {
            this.userVerifyStatData1 = res.data.data;
          } else {
            this.userVerifyStatData2 = res.data.data;
          }
          this.loading = false;
        }
      );
    },
    getReportDeptList() {
      this.$get("/report/report/depts").then((res) => {
        this.reportDeptData = res.data.data;
        this.setSelected(
          "reportDeptIds",
          "reportDeptData",
          "deptId",
          "reportDeptAll"
        );
      });
    },
    getGroupList() {
      this.dataGroup = [];
      this.$get("patientgroup", { module: 4 }).then((res) => {
        this.dataGroup = res.data.data;
        if (this.patientGroupId) {
          this.handleGroupClick({ key: this.patientGroupId }, true);
        }
      });
    },
    update() {
      this.getList();
    },
    updateRowsPop() {
      this.rowsPop = true;

    },
    updateRows() {
      this.rows = null;
      this.rowsPop = false;
    },
    // 首次加载时获取缓存的列表筛选值
    getStorage() {
      if (localStorage.getItem("REPORT_FILTER")) {
        const params = JSON.parse(localStorage.getItem("REPORT_FILTER"));
        this.pageSize = params.pageSize;
        this.page = params.pageNum;
        this.operateStatus = params.operateStatus;
        this.hosBarCode = params.hosBarCode;
        this.verifyStatus = params.verifyStatus;
        this.patientGroupId = params.patientGroupId;
        this.submitterUserId = params.submitterUserId;
        this.verifyUserId = params.verifyUserId;
        this.seqDeptId = params.seqDeptId;
        this.hospitalIds = params.hospitalIds ? params.hospitalIds : [];
        this.trackingStatus = params.trackingStatus
          ? params.trackingStatus
          : [];
        this.warning = params.warning;
        this.mdCheck = params.mdCheck;
        this.mdRead = params.mdRead;
        this.applyItem = params.applyItem;
        this.molecularTypingId = params.molecularTypingId;
        if (this.operateStatus) {
          this.checkStatus({ key: this.operateStatus }, true);
        }
        if (this.verifyStatus) {
          this.checkVerifyStatus({ key: this.verifyStatus }, true);
        }
        if (this.mdCheck) {
          this.checkMdCheckStatus({ key: this.mdCheck }, true);
        }
      }
      this.getList();
    },
    // 首次加载时 设置已选中状态
    // selectedId:已选id-[],selectedData:所有数据-[],key:接口数据中对应的id-'',allFlag:全选-bool
    setSelected(selectedId, selectedData, key, allFlag) {
      selectedId = this[selectedId];
      if (!selectedId) {
        return false;
      }
      selectedData = this[selectedData];
      if (selectedId.length) {
        selectedData.forEach(function (item) {
          if (selectedId.indexOf(item[key]) > -1) {
            item.isSelected = true;
          } else {
            item.isSelected = false;
          }
        });
      } else {
        this[allFlag] = true;
      }
    },
    onClose() {
      this.drawerVisible = false;
      this.drawerCollectVisible = false;
    },
    resetDrawer() {
      this.page = 1;
      this.patientGroupId = "";
      this.operateStatus = "";
      this.verifyStatus = "";
      this.mdCheck = "";
      this.mdRead = "";
      this.applyItem = "";
      this.verifyUserId = "";
      this.submitterUserId = "";
      this.seqDeptId = "";
      this.trackingStatus = [];
      this.hospitalIds = [];
      this.reportDeptIds = [];
      this.trackingStatusALL = true;
      this.hospitalAll = true;
      this.reportDeptAll = true;
      this.getList();
    },
    okDrawer() {
      this.page = 1;
      this.drawerVisible = false;
      this.getList();
    },
    getTrackingData() {
      this.$get("report/report/getTrackingStatusFilterStat", { module: 4 }).then((res) => {
        this.trackingData = res.data.data;
        this.handleTrankingData();
      });
    },
    handleTrankingData() {
      const self = this;
      // for (let i = self.trackingData.length - 1; i >= 0; i--) {
      //   const item = self.trackingData[i];
      //   if (self.trackingShow.indexOf(item.value) == -1) {
      //     self.trackingData.splice(i, 1);
      //   }
      // }
      self.setSelected(
        "trackingStatus",
        "trackingData",
        "keyId",
        "trackingStatusALL"
      );
    },
    // item 选中数据
    // option参数 key:接口数据中对应的id-'',value:页面显示的选项文字-'',paramsKey:列表接口需要的key名-'',allFlag:全选-bool,allData:所有数据-[]
    searchCheckbox(item, option) {
      const key = option.key,
        name = option.value,
        paramsKey = option.paramsKey,
        allFlag = option.allFlag,
        allData = option.allData;
      if (item) {
        item.isSelected = !item.isSelected;
        this[allFlag] = false;
        if (item.isSelected) {
          this[paramsKey].push(item[key]);
        } else {
          this[paramsKey].splice(this[paramsKey].indexOf(item[key]), 1);
        }
        if (this[paramsKey].length == 0) {
          this[allFlag] = true;
        }
      } else {
        this[allFlag] = true;
        this[paramsKey] = [];
        this[allData].forEach(function (item) {
          item.isSelected = false;
        });
      }
    },
    ckWarning(e) {
      this.page = 1;
      this.getList();
    },
    gethospital() {
      this.$get("report/report/findDeptStatList", { module: 4 }).then((res) => {
        this.hospitalData = res.data.data;
        this.setSelected(
          "hospitalIds",
          "hospitalData",
          "keyId",
          "hospitalAll"
        );
      });
      this.$get("dept/findDeptTreeList", {
        pageSize: 10000,
        deptType: 2,
      }).then((res) => {
        this.sequenceData = res.data.data[0].children;
      });
    },
    getCommonDict() {
      this.$get("report/report/getApplyItemFilterStat", { module: 4 }).then((res) => {
        this.commonDictData = res.data.data;
      });
    },
    getMDCheckValue() {
      this.mdCheckData = [];
      this.$get("md/getMDCheckValue", { module: 4 }).then((res) => {
        this.mdCheckData = res.data.data;
      });
    },
    getMDReadValue() {
      this.$get("md/getMDReadValue", { module: 4 }).then((res) => {
        this.mdReadList = res.data.data;
      });
    },
    getOperateUserFilterStat(type) {
      this.$get("jobsmanage/jobs/getOperateUserFilterStat", { type: type }).then((res) => {
        if (type == 1) {
          this.operateUserFilterStat1 = res.data.data;
        } else {
          this.operateUserFilterStat2 = res.data.data;
        }
      });
    },
    getSequenceFilterStat() {
      this.$get("report/report/getSequenceFilterStat", { module: 4 }).then((res) => {
        this.sequenceFilterStat = res.data.data;
      });
    },
    // 选择组 查询
    handleGroupClick(e, bol) {
      if (e.key == "default") {
        this.groupTitle = "请选择";
        this.patientGroupId = "";
      } else {
        this.dataGroup.forEach((item, index) => {
          if (item.id == e.key) {
            this.groupTitle = item.groupName;
            return;
          }
        });
        this.patientGroupId = e.key;
      }
    },
    handleOperateUserFilterStatClick(e, bol) {
      if (e.type == 1) {
        if (e.key == "default") {
          this.submitterUserId = "";
        } else {
          this.submitterUserId = e.key;
        }
      } else {
        if (e.key == "default") {
          this.verifyUserId = "";
        } else {
          this.verifyUserId = e.key;
        }
      }

    },
    handleSequenceFilterStatClick(e) {
      if (e.key == "default") {
        this.seqDeptId = "";
      } else {
        this.seqDeptId = e.key;
      }

    },
    checkMdCheckStatus(e, bol) {
      if (e.key == "default") {
        this.mdCheckText = "MD审核状态";
        this.mdCheck = "";
      } else {
        this.mdCheckData.forEach((item, index) => {
          if (item.id == e.key) {
            this.mdCheckText = item.name;
            return;
          }
        });
        this.mdCheck = e.key;
      }
    },
    checkMdReadStatus(e) {
      if (e.key == "default") {
        this.mdReadText = "MD已读";
        this.mdRead = "";
      } else {
        this.mdReadList.forEach((item, index) => {
          if (item.keyId == e.key) {
            this.mdReadText = item.value;
            return;
          }
        });
        this.mdRead = e.key;
      }
    },
    checkApplyItem(e) {
      if (e.key == "default") {
        this.applyItem = "";
      } else {
        this.commonDictData.forEach((item, index) => {
          if (item.dictKey == e.key) {
            return;
          }
        });
        this.applyItem = e.key;
      }
    },
    checkStatus(e, bol) {
      if (e.key == "default") {
        this.statusText = "报告状态";
        this.operateStatus = "";
      } else {
        this.operateData.forEach((item, index) => {
          if (item.id == e.key) {
            this.statusText = item.name;
            return;
          }
        });
        this.operateStatus = e.key;
      }
    },
    checkVerifyStatus(e, bol) {
      if (e.key == "default") {
        this.verifyStatusText = "审核状态";
        this.verifyStatus = "";
      } else {
        this.verifyStatusStatData.forEach((item, index) => {
          if (item.keyId == e.key) {
            this.verifyStatusText = item.value;
            return;
          }
        });
        this.verifyStatus = e.key;
      }
    },
    closeModel() {
      this.isAppoint = 0;
      this.visible = false;
    },
    closeConfirm() {
      this.confirmVisible = false;
    },
    okClick() {
      this.confirmVisible = false;
      if (this.currentConfirmData.operateType == "confirm-dept") {
        this.isAppoint = 2;
      } else {
        this.isAppoint = 1;
      }
      this.visible = true;
    },
    appoint() {
      const dept = this.selectRows.some((item) => {
        return !!item.deptId;
      });
      if (this.selectRows.length == 0) {
        this.$message.warning("请选择数据后进行指派");
        return;
      } else if (dept) {
        this.confirmVisible = true;
        this.currentConfirmData = this.conAppointDept;
      } else {
        this.isAppoint = 2;
        this.visible = true;
      }
    },
    //请选择时间区间 导出
    onChangePicker(val, dateString) {
      if (dateString.length > 0) {
        this.rPrckerVal = val;
        this.exportSettlementOpt['startTime'] = dateString[0];
        this.exportSettlementOpt['endTime'] = dateString[1];
      }
    },
    onChangeSelectTType(selectedItems) {
      this.exportSettlementOpt['timeType'] = selectedItems;
    },
    onChangeSelectHOperate(selectedItems) {
      this.exportSettlementOpt['hosOperate'] = selectedItems;
    },
    onChangeSelectHId(selectedItems) {
      this.exportSettlementOpt['hosId'] = selectedItems;
    },
    onChangeSelectSOperate(selectedItems) {
      this.exportSettlementOpt['seqOperate'] = selectedItems;
    },
    onChangeSelectSequenceId(selectedItems) {
      this.exportSettlementOpt['seqId'] = selectedItems;
    },
    exportSettlement() {
      if (this.exportSettlementOpt.timeType == undefined || !this.exportSettlementOpt.startTime || !this.exportSettlementOpt.endTime) {
        this.$message.error('请选择查询时间！');
      } else {
        this.$export('/jobsmanage/jobs/ds', this.exportSettlementOpt, '结算');
      }
    },
    exportExcelClick() {
      let params = {
        operateStatus: this.operateStatus,
        hosBarCode: this.hosBarCode,
        verifyStatus: this.verifyStatus,
        patientGroupId: this.patientGroupId,
        submitterUserId: this.submitterUserId,
        verifyUserId: this.verifyUserId,
        seqDeptId: this.seqDeptId,
        hospitalIds: this.hospitalIds,
        trackingStatus: this.trackingStatus,
        searchDeptId: this.reportDeptIds,
        warning: this.warning,
        mdCheck: this.mdCheck,
        mdRead: this.mdRead,
        molecularTypingId: this.molecularTypingId,
        applyItem: this.applyItem,
      };
      params = this.deleteEmpty(params);
      if (params.warning) {
        params.warning = 1;
      }
      if (typeof params.molecularTypingId === "Array") {
        params.molecularTypingId = params.molecularTypingId.join(",");
      }

      this.$export('/report/report/down', params, '报告管理列表');
    },
    appointPeople() {
      this.appointType = 1;
      if (this.selectRows.length > 0) {
        let flag = 0;
        for (let val of this.selectRows) {
          if (val.verifyId) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        if (flag == 1) {
          this.currentConfirmData = this.conAppointRePeople;
          this.confirmVisible = true;
        } else {
          this.isAppoint = 1;
          this.visible = true;
        }
      } else {
        this.$message.error("请选择数据后进行指派");
      }
    },
    appointSubmitPeople() {
      this.appointType = 0;
      if (this.selectRows.length > 0) {
        let flag = 0;
        for (let val of this.selectRows) {
          if (
            val.verifyStatus == 1 ||
            val.verifyStatus == 3 ||
            val.verifyStatus == 5
          ) {
            flag = 1;
            break;
          } else if (
            (val.verifyStatus == 0 ||
              val.verifyStatus == 2 ||
              val.verifyStatus == 4) &&
            val.submitterId
          ) {
            flag = 2;
            break;
          } else {
            flag = 0;
          }
        }
        if (flag == 0) {
          this.isAppoint = 1;
          this.visible = true;
        } else if (flag == 1) {
          this.$message.error("此状态不可指派");
        } else if (flag == 2) {
          this.currentConfirmData = this.conAppointPeople;
          this.confirmVisible = true;
        }
      } else {
        this.$message.error("请选择数据后进行指派");
      }
    },
    goToDetails(record) {
      if (auth.auth("10601")) {
        this.$router.push({
          path: "/report/details",
          query: { id: record.id },
        });
      }
    },
    getBigTypes() {
      this.$post(
        "base/baseInfo/findOperateByBigClassify",
        ["report"],
        true
      ).then((res) => {
        this.reportStatusAry = res.data.data;
      });
    },
    pageChange(page, pagesize) {
      this.page = page;
      this.pageSize = pagesize;
      this.getList();
    },
    onSearch() {
      this.page = 1;
      this.getList();
    },
    onChangeMtOptions(value) {
      if (value) {
        this.molecularTypingId = value;
      }
      this.page = 1;
      this.getList();
    },
    // 删除params里空值
    deleteEmpty(params) {
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (!value || (Array.isArray(value) && value.length == 0)) {
          delete params[key];
        }
      });
      return params;
    },
    getList() {
      this.loading = true;
      let params = {
        operateStatus: this.operateStatus,
        hosBarCode: this.hosBarCode,
        verifyStatus: this.verifyStatus,
        patientGroupId: this.patientGroupId,
        submitterUserId: this.submitterUserId,
        verifyUserId: this.verifyUserId,
        seqDeptId: this.seqDeptId,
        hospitalIds: this.hospitalIds,
        trackingStatus: this.trackingStatus,
        searchDeptId: this.reportDeptIds,
        pageSize: this.pageSize,
        pageNum: this.page,
        warning: this.warning,
        mdCheck: this.mdCheck,
        mdRead: this.mdRead,
        molecularTypingId: this.molecularTypingId,
        applyItem: this.applyItem,
      };
      params = this.deleteEmpty(params);
      localStorage.setItem("REPORT_FILTER", JSON.stringify(params));
      if (params.warning) {
        params.warning = 1;
      }
      if (typeof params.molecularTypingId === "Array") {
        params.molecularTypingId = params.molecularTypingId.join(",");
      }
      this.$get("report/report/page", params).then((res) => {
        this.reportData = res.data.data;
        this.selectedRowKeys = [];
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.export-popover {
  .export-content {
    padding: 0px 10px;
    line-height: 32px;

    .export-a-row-h {
      padding-bottom: 7px;
    }

    .export-popover-label {
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #a4a4a4;
      text-align: right;
    }

    .tool-item {
      width: 210px;
    }

    .export-btn {
      float: right;
      margin-right: 8px;
      font-size: 12px;
    }
  }
}

.drawer-page-content {
  padding-bottom: 25px;

  /deep/ .hospital-table .ant-table-middle .ant-table-thead th {
    height: 42px;
  }

  /deep/ .hospital-table .ant-table-middle .ant-table-body .ant-table-row>td {
    height: 42px;
  }
}

.sample-page {
  width: 100%;
  min-width: 1200px;

  .h-mdCheck {
    display: inline-block;
    padding: 0px 4px;
    color: #fff;
    background-color: #1890ff;
    line-height: 20px;
    font-size: 12px;
    border-radius: 2px;

    &.not {
      background-color: #c4c4c4;
    }

    &.red {
      background-color: #ff0000;
    }
  }

  .mr20 {
    margin-right: 20px;
  }

  .ml20 {
    margin-left: 20px;
  }

  .page-handle {
    height: 60px;
    background: #f8fbfb;
    padding: 0 40px;
    line-height: 60px;
    border-top: 1px solid rgba(240, 242, 245, 1);
    border-bottom: 1px solid rgba(240, 242, 245, 1);

    .right {
      float: right;
      height: 60px;

      .hospital-dropdown-link {
        margin-left: 25px;
      }

      .hospital-dropdown-link {
        color: #3e7ff7;
        font-size: 12px;
      }
    }

    .left {
      height: 60px;
      float: left;

      .ant-btn+.ant-btn {
        margin-left: 5px;
      }
    }
  }

  .breadcrumb-num {
    display: inline-block;
    margin-left: 15px;
    font-size: 14px;
    color: #a4a4a4;

    .span-num {
      color: #333;
      margin-left: 5px;
    }
  }

  .page-content {
    padding: 20px 40px;
    background: #fff;

    /deep/ .clickrowstyle {
      td {
        background: #e6f7ff;
      }
    }

    .pagination {
      margin: 20px 0;
      text-align: right;
    }
  }
}

.icon-checked {
  float: right;
  color: #4c84ff;
  line-height: 22px;
  margin-left: 10px;
}
</style>